// src/routes/domains/ireland/index.ts
import { irelandRoutes } from './ireland.routes';
import type { AppRoute } from '../../core/types';

/**
 * Lazy export wrapper for Ireland routes.
 * Enables code splitting: the Ireland routes chunk will only load when needed.
 */
export const loadIrelandRoutes = (): Promise<AppRoute[]> => {
  return Promise.resolve(irelandRoutes);
};
